export const MESES_ABREV = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

export const formatCurrency = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v || 0));

export const formatPercent = (v) => `${Number(v || 0).toFixed(2)}%`;

// "Valor Atual" é o valor por usuário (não o total). O valor mensal base é
// Valor Atual × Qtde Usuário Atual — é sobre esse total que a inflação/reajuste incide.
export function calcValorUnitario(item) {
  return Number(item.valor_atual || 0);
}

export function calcValorMensalBase(item) {
  return calcValorUnitario(item) * Number(item.qtde_usuario_atual || 0);
}

// reajustes: lista de alterações de valor cadastradas no item (tipo_indice + mes + percentual
// cada), aplicadas no mês cadastrado sobre o valor UNITÁRIO — a partir daí o preço por usuário
// já reajustado permanece composto e é usado em TODOS os meses seguintes, inclusive nos meses
// de expansão (o incremento de novos usuários também é precificado pelo valor já reajustado,
// não pelo valor original — o cálculo é dinâmico mês a mês, não uma soma fixa). Uma despesa
// pode mudar de valor mais de uma vez no ano — os reajustes são aplicados em ordem crescente
// de mês, compostos (2 reajustes no mesmo mês aplicam ambos, na ordem em que foram cadastrados).
// expansoes: lista de janelas de mudança da quantidade de usuários (qtde_usuario_novo + vigência
// mes_inicio/mes_fim cada) — fora da janela de cada evento a quantidade volta a ser qtdeAtual;
// dentro dela soma-se unitario × (qtde_usuario_novo − qtdeAtual). Uma despesa pode mudar de
// quantidade mais de uma vez no ano (ex: 10→15 em Março, 15→20 em Julho); eventos com janelas
// que se sobrepõem no mesmo mês têm seus incrementos somados. Cada expansão pode opcionalmente
// trazer valor_usuario_novo (ex: desconto por volume negociado junto com o aumento de qtde) —
// quando informado, é ele (não o unitário reajustado do item) que precifica a nova qtde total
// da janela; sem ele, o comportamento é o mesmo de antes (usa o unitário vigente do item).
// mes_inicio_valor/mes_fim_valor: vigência do Valor Atual (mesma mecânica das janelas de
// expansão, mas independente delas) — fora do intervalo, a base (valor atual × qtde atual)
// conta como 0 no mês, mas o incremento de expansão continua sendo somado se dentro da sua
// própria janela.
export function calcProjecaoMensal(item) {
  const {
    qtde_usuario_atual,
    mes_inicio_valor, mes_fim_valor, reajustes, expansoes,
  } = item;

  const qtdeAtual = Number(qtde_usuario_atual || 0);
  let unitario = calcValorUnitario(item);

  const reajustesPorMes = {};
  for (const r of reajustes || []) {
    (reajustesPorMes[r.mes] ||= []).push(r);
  }

  const projecao = [];
  for (let mes = 1; mes <= 12; mes++) {
    for (const r of reajustesPorMes[mes] || []) {
      unitario = unitario * (1 + Number(r.percentual || 0) / 100);
    }

    const dentroVigenciaValor =
      !mes_inicio_valor || !mes_fim_valor || (mes >= mes_inicio_valor && mes <= mes_fim_valor);

    const unitarioDoMes = unitario;
    const base = dentroVigenciaValor ? unitarioDoMes * qtdeAtual : 0;
    const incremento = (expansoes || [])
      .filter((e) => mes >= e.mes_inicio && mes <= e.mes_fim)
      .reduce((acc, e) => {
        const valorUsuarioNovo = e.valor_usuario_novo === "" || e.valor_usuario_novo === undefined || e.valor_usuario_novo === null
          ? unitarioDoMes
          : Number(e.valor_usuario_novo);
        return acc + valorUsuarioNovo * Number(e.qtde_usuario_novo || 0) - unitarioDoMes * qtdeAtual;
      }, 0);
    projecao.push(base + incremento);
  }
  return projecao;
}

export function calcTotalAnual(projecaoMensal) {
  return (projecaoMensal || []).reduce((acc, v) => acc + Number(v || 0), 0);
}

export function somarProjecoes(listaDeProjecoes) {
  const total = new Array(12).fill(0);
  for (const projecao of listaDeProjecoes) {
    for (let i = 0; i < 12; i++) total[i] += Number(projecao[i] || 0);
  }
  return total;
}
